import { push, ref, set, update } from "firebase/database";

export const formatMessagesWithHeaders = (messages) => {
    if (!messages.length) return [];

    const formattedMessages = [];
    let lastSenderId = null;

    messages.forEach((message, index) => {
        const showHeader =
            lastSenderId !== message.senderId ||
            (index > 0 && messages[index - 1].senderId !== message.senderId);

        formattedMessages.push({
            ...message,
            showHeader,
        });

        lastSenderId = message.senderId;
    });

    return formattedMessages;
};

export const groupMessagesByDate = (messages, formatDate) => {
    return messages.reduce((groups, message) => {
        const date = formatDate(message.timestamp);
        if (!groups[date]) {
            groups[date] = [];
        }
        groups[date].push(message);
        return groups;
    }, {});
};

export const formatGroupedMessages = (groupedMessages, formatMessagesWithHeaders) => {
    return Object.entries(groupedMessages).map(([date, dateMessages]) => ({
        date,
        messages: formatMessagesWithHeaders(dateMessages),
    }));
};

export const prepareReplyDatd = (message, currentUserId, senderName) => {
    const replyData = {
        id: message.id,
        senderId: message.senderId,
        senderName: message.senderId === currentUserId ? "You" : senderName,
        text: message.text,
        imageUrl: message.imageUrl,
        audioUrl: message.audioUrl
    };

    if (!message.text) {
        if (message.imageUrl) {
            replyData.displayText = "📷 Photo";
        } else if (message.audioUrl) {
            replyData.displayText = "🎤 Voice message";
        }
    }

    return replyData;
};

export const createMessageWithReply = (text, senderId, replyTo) => {
    const messageData = {
        text,
        senderId,
        timestamp: Date.now(),
    };

    if (replyTo) {
        messageData.replyTo = {
            messageId: replyTo.id,
            senderId: replyTo.senderId,
        };

        if (replyTo.text) {
            messageData.replyTo.text = replyTo.text;
        } else if (replyTo.imageUrl) {
            messageData.replyTo.imageUrl = replyTo.imageUrl;
            messageData.replyTo.displayText = "📷 Photo";
        } else if (replyTo.audioUrl) {
            messageData.replyTo.audioUrl = replyTo.audioUrl;
            messageData.replyTo.displayText = "🎤 Voice message";
        }
    }

    return messageData;
};

// utils/callUtils.js or add to your existing utils.js

export const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
};